module.exports = __webpack_public_path__ + "assets/img/background_color.aee35da.jpeg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/background_color.jpeg
// module id = pDqk
// module chunks = 50